import { useContext } from 'react';

import HamburgerMenu from './HamburgerMenu.jsx';
import LdsIcon from '../LdsIcon/index.jsx';
import { LdsHeaderContext } from './LdsHeaderProvider.jsx';

export default function HeaderIcons({
  // Search props
  searchMobileBtnAriaLabel,
  searchMobileCloseAriaLabel = 'Close search',
  searchMobileCloseLabel = 'Close',
  searchOpenedAnnouncement = 'Search open',
  searchClosedAnnouncement = 'Search closed',
  // Hamburger Menu props
  labelMenu,
  labelMobileMenuClosed,
  labelMobileMenuOpened,
  toggleMobileMenu,
  isMobileMenuOpen,
}) {
  const {
    isSearchOpen,
    setIsSearchOpen,
  } = useContext(LdsHeaderContext);

  return (
    <div className="header-icons-wrapper">
      {/* Search */}

      {
        !isSearchOpen && <button
          className="lds-button-base mobile-search-button"
          aria-label={searchMobileBtnAriaLabel}
          onClick={() => setIsSearchOpen(true)}
        >
          <LdsIcon decorative inline name="magnifying-glass" />
        </button>
      }
      {
        isSearchOpen && <button
          className="lds-button-base mobile-search-button d-flex flex-column"
          aria-label={searchMobileCloseAriaLabel}
          onClick={() => setIsSearchOpen(false)}
        >
          <LdsIcon decorative inline name="x" />
          <span className="lds-header-toggle-text">{searchMobileCloseLabel}</span>
        </button>
      }

      {/*
        Hamburger Menu
        Does not display if search modal is open
      */}
      {
        !isSearchOpen && <HamburgerMenu
          labelMenu={labelMenu || 'Menu'}
          toggleMobileMenu={toggleMobileMenu}
          openMenuButtonRef={null}
          isMobileMenuOpen={isMobileMenuOpen}
          labelMobileMenuOpened={labelMobileMenuOpened}
          labelMobileMenuClosed={labelMobileMenuClosed}
        />
      }
      <div aria-live="polite" className="screen-reader-text">
        {isSearchOpen ? searchOpenedAnnouncement : searchClosedAnnouncement}
      </div>
    </div>
  );
}
